// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import { IconWrapper } from "@insite/mobius/Icon";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import { productListFilterAccordionSectionStyles } from "@turnerBlueprint/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import IconMinus from "@turnerBlueprint/XDL/Icons/IconMinus";
import IconPlus from "@turnerBlueprint/XDL/Icons/IconPlus";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color, styledScrollbar } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    expandIconProps: {
        src: ChevronDown,
    },
    collapseIconProps: {
        src: ChevronUp,
    },
    titleTypographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        css: css`
            &&& {
                line-height: 14px;
                margin: 0;
            }
        `,
    },
    panelProps: {
        css: css`
            border: none;
            border-top: 1px solid ${color("common.border")};
            padding: 12px 0px 8px 9px;
        `,
    },
    toggleTransition: {
        positionerCss: css`
            border-left: 0;
            padding-left: 0;
            height: 100%;
            top: 10px;
            max-height: fit-content;
            &&& ${IconWrapper}, &&& ${IconWrapper} svg {
                width: 15px;
                height: 20px;
            }
        `,
        transitionCss: css``,
    },
    headerProps: {
        css: css`
            border-top: 1px solid ${color("common.border")};
            margin: 0;
            &&& button,
            &&& button:focus {
                margin-bottom: 0;
                padding: 9px 10px;
                border: none;
                line-height: 13px;
                background: ${color("common.white")};
            }
        `,
    },
};

productListFilterAccordionSectionStyles.checkBox = productListFilterAccordionSectionStyles.checkBoxSelected = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        width: 100%;
        span[role="checkbox"] {
            margin: 0;
        }
        label {
            display: flex;
            justify-content: space-between;
            margin-right: 0;
            height: auto;
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-word;
            line-height: 14px;
            height: 15px;
            display: flex;
            width: 100%;
            span {
                word-break: keep-all;
            }
        `,
    },
};

productListFilterAccordionSectionStyles.facetCount = {
    color: "common.ui6",
    css: css`
        margin-left: auto;
    `,
};

productListFilterAccordionSectionStyles.seeAllLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 13px;
        `,
    },
    icon: {
        position: "right",
        iconProps: {
            src: IconPlus,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
    },
};

productListFilterAccordionSectionStyles.seeLessLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 13px;
        `,
    },
    icon: {
        position: "right",
        iconProps: {
            src: IconMinus,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
    },
};

productListFilterAccordionSectionStyles.scrollableContainer = {
    css: css`
        max-height: 292px;
        padding-right: 10px;
        ${styledScrollbar()};
    `,
};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        overflow-x: hidden;
        flex-direction: row;
        &:not(:last-child) {
            padding-bottom: 8px;
        }
    `,
};
